/**
 * Created by xiajing on 2017/6/9.
 */
import {serviceRequestActions} from '../actions'
import * as types  from '../constants/ActionTypes'
let middleware = ({dispatch, getState}) => {
    return next => action => {
        var appState = getState().app
        //start session
        if (action.type === types.SEND_SESSION_START_FINISH) {
            var appState = getState().app
            if (appState.dashboard.currentCustomerInfo) {
                var req = {
                    _id: appState.dashboard.currentCustomerInfo._id
                }
                //According save userInfo success return objId to  update serverRequest userInfo customerId
                dispatch(serviceRequestActions.updateCustomerId(req))
            }
        }

        return next(action)
    }
}
export default middleware
